// Shared avatar fallbacks for the messaging UI (conversation list, chat header,
// message bubbles): a deterministic color keyed by id plus name initials.

const AVATAR_COLORS = [
  '#27AA83', // green-600
  '#1F7AE0', // blue-600
  '#7C3AED', // purple-600
  '#D97706', // amber-600
  '#DC2626', // red-600
  '#0891B2', // cyan-600
  '#EA580C', // orange-600
];

export function avatarInitials(name) {
  const words = (name || '?').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

export function avatarColor(id) {
  return AVATAR_COLORS[(id || 0) % AVATAR_COLORS.length];
}
